module.exports = __webpack_public_path__ + "img/tractorUnitRearLeftOutline.14a0abc7.svg";